import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GraphUser } from '@gbr-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class GraphService {
    private readonly httpClient = inject(HttpClient);
    private readonly msGraphApiUrl = 'https://graph.microsoft.com/v1.0';

    /**
     * Get the current user's profile with specific properties
     * @param select Array of property names to retrieve from GraphUser
     * @returns Observable of user object with only selected properties, typed based on select parameter
     */
    getMeWithSelect<K extends keyof GraphUser>(select: K[]): Observable<Pick<GraphUser, K>> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        const selectParam = select.join(',');

        return this.httpClient.get<Pick<GraphUser, K>>(`${this.msGraphApiUrl}/me?$select=${selectParam}`, {
            headers
        });
    }
}
